import React from 'react';
import './index.css';



function About() {
  return (
    <section id="about">
      <h2>About</h2>
      <p>born in tokyo, currently living in new york, mayumi ishino received an mfa in sculpture from new york academy of art. mayumi combines studio art practice, performance, directing, site-specific installation, and video, presenting her work in national and international institutions including: exit art, ny; art news projekts, berlin; 3rd international performance festival, indonesia. awards include: manhattan community art fund; immigrant artists project at the new york foundation for the arts; the virginia center for the creative arts; i-park; constance saltonstall foundation for the arts; and hrh prince of wales prize.</p>
    </section>
  );
}

export default About;
